import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { withTranslation } from 'language/i18n';
import types from 'constants/types';
import { MACHINE_STATE } from 'constants/common';

const BidCounter = ({ t, machine, timeLeft }) => {
  const handleHeadColor = () => {
    if (machine.state === MACHINE_STATE.SOLD || machine.state === MACHINE_STATE.SUSPENDED) {
      return 'gray';
    }
    if (moment().isSameOrBefore(machine.event.startDate)) {
      return 'gray';
    }
    if (timeLeft?.days > 1) {
      return 'green';
    }
    return 'red';
  };

  const bidTitleText = useMemo(() => {
    if (moment().isSameOrBefore(machine.event.startDate)) {
      return 'Açık artırmanın başlamasına';
    }
    return 'Açık artırmanın bitmesine';
  }, [machine]);

  return (
    <div className="im-box im-box--white im-box--border-radius im-box--padding-0">
      {
        (!_.isEmpty(timeLeft) || machine.state === MACHINE_STATE.SOLD || machine.state === MACHINE_STATE.SUSPENDED)
        && (
          <div className={`im-bidding-head im-bidding-head--${handleHeadColor()} justify-content-center`}>
            {
              machine.state === MACHINE_STATE.SOLD || machine.state === MACHINE_STATE.SUSPENDED
                ? (
                  <div className="fs-25 fw-700 text-center">
                    {types[machine.state].toLocaleUpperCase('tr')}
                  </div>
                )
                : (
                  <div className="fs-25 fw-700 text-center">
                    <span className="fw-700 fs-15">{bidTitleText}</span>
                    <br />
                    {
                      _.result(timeLeft, 'days') !== undefined && timeLeft.days > 0
                      && (
                        <>
                          <span className="ml-1 mr-1">{timeLeft.days < 10 ? `0${timeLeft.days}` : timeLeft.days}</span>
                          <span className="fs-15">{t('day')}</span>
                        </>
                      )

                    }
                    {
                      _.result(timeLeft, 'hours') !== undefined
                      && (
                        <>
                          <span className="ml-1 mr-1">{timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours}</span>
                          <span className="fs-15">{t('hr')}</span>
                        </>
                      )

                    }
                    {
                      _.result(timeLeft, 'minutes') !== undefined
                      && (
                        <>
                          <span className="ml-1 mr-1">{timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}</span>
                          <span className="fs-15">{t('min')}</span>
                        </>
                      )

                    }
                    {
                      _.result(timeLeft, 'seconds') !== undefined
                      && (
                        <>
                          <span className="ml-1 mr-1">{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}</span>
                          <span className="fs-15">{t('sec')}</span>
                        </>
                      )

                    }
                  </div>
                )
            }
          </div>
        )
      }
    </div>
  );
};

BidCounter.propTypes = {
  t: PropTypes.func,
  machine: PropTypes.object,
  timeLeft: PropTypes.object,
};

export default withTranslation('common')(BidCounter);
